/**
 * Map version configurations to their names
 */
export const configurationVersions = {
  swing: "Swing Education",
  "1": "District A (Test Only)",
  "2": "District B (Test Only)",
} as const;

/**
 * Type representing valid version configurations
 */
export type Version = keyof typeof configurationVersions;

/**
 * Given a `version`, return lazily the matching configuration
 */
export async function getConfiguration(version: Version) {
  switch (version) {
    case "swing":
      return (await import("./swing")).SwingConfiguration;
    case "1":
      return (await import("./testDistrictA")).TestDistrictAConfiguration;
    case "2":
      return (await import("./testDistrictB")).TestDistrictBConfiguration;
    default:
      throw new Error(`Invalid version: ${version}`);
  }
}
